import { Icon } from '@/components/foundations';

/**
 * Seletor de período do cabeçalho (`.dropdown`). Hoje só exibe o valor (mock);
 * a interação vem com o Dropdown do design system (issue #7).
 */
export function PeriodPicker({ value, minWidth = 204 }: { value: string; minWidth?: number }) {
  return (
    <label className="dropdown" style={{ minWidth }}>
      <Icon name="cal" />
      {value}
      <Icon name="down" />
    </label>
  );
}
